import { render, staticRenderFns } from "./PolicyDetailsView.vue?vue&type=template&id=23ffbabf"
import script from "./PolicyDetailsView.vue?vue&type=script&lang=js"
export * from "./PolicyDetailsView.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetailsView.vue?vue&type=style&index=0&id=23ffbabf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports